import {
  CatDropdown,
  CatList,
  CatListItem
} from 'components/blocks-components';
import { PurifiedHtml } from 'components/purified-html';

const ProductDiagramDropdown = ({ selectOptions, selectedTitle, onSelect }) => {
  const onChangeDropdown = (e) => {
    onSelect(e?.detail.value);
  };

  return (
    <div className="cat-u-padding-bottom-md">
      {selectOptions.length > 1 ? (
        <CatDropdown
          label={selectedTitle}
          placeholder={selectedTitle}
          data-testid="cat-dropdown"
          size="sm"
          onBlSelect={(e) => {
            onChangeDropdown(e);
          }}
        >
          <CatList spacing="padded">
            {selectOptions.map((title) => {
              return (
                <CatListItem value={title} key={title}>
                  <PurifiedHtml htmlString={title} />
                </CatListItem>
              );
            })}
          </CatList>
        </CatDropdown>
      ) : (
        <PurifiedHtml htmlString={selectOptions[0]} />
      )}
    </div>
  );
};

export default ProductDiagramDropdown;
